import './App.css';
import Sidebar from './Sidebar';
import 'bootstrap/dist/css/bootstrap.min.css';
import { useCookies } from 'react-cookie';
import './Main.css';
import { FaCloudUploadAlt } from "react-icons/fa";
import Background from './Background';
import { useState, useEffect, useCallback, useRef } from 'react';
import {useDropzone} from 'react-dropzone';
import { ToastContainer, toast } from 'react-toastify';
import { useHistory } from 'react-router-dom';
import React from 'react';

function AddBanner() {
    const history = useHistory();
    const [cookies, setCookie] = useCookies(['user']);
    const [userId, setUserId] = useState("");
    const [priority, setPriority] = useState(0);
    const [link, setLink] = useState("");
    const [imageFile, setImageFile] = useState(null);
    const [imagePreview, setImagePreview] = useState(null);
    const [isLoading, setIsLoading] = useState(false);
    const [userSearchTerm, setUserSearchTerm] = useState("");
    const [userList, setUserList] = useState([]);
    const [showUserDropdown, setShowUserDropdown] = useState(false);
    const [selectedUser, setSelectedUser] = useState(null);
    const userDropdownRef = useRef(null);

    const onDrop = useCallback(acceptedFiles => {
        if (acceptedFiles && acceptedFiles.length > 0) {
            const file = acceptedFiles[0];
            setImageFile(file);
            const reader = new FileReader();
            reader.onload = (e) => {
                setImagePreview(e.target.result);
            };
            reader.readAsDataURL(file);
        }
    }, []);

    const {getRootProps, getInputProps, isDragActive} = useDropzone({
        onDrop,
        accept: {
            'image/*': ['.jpeg', '.jpg', '.png', '.gif']
        },
        maxFiles: 1
    });

    const searchUsers = (searchTerm) => {
        if (!searchTerm || searchTerm.length < 2) {
            setUserList([]);
            return;
        }

        var data = new FormData();
        data.append("sort_by", "created_at");
        data.append("sorting_order", "desc");
        data.append("page", 1);
        data.append("page_size", 20);
        data.append("search_term", searchTerm);

        fetch('https://api.connecker.com/api/get_all_users', {
            method: 'POST',
            body: data
        }).then(res => {
            if(!res.ok) {
                throw Error('Could not fetch');
            }
            return res.json();
        }).then(data => {
            if(data.response_code == 200) {
                setUserList(data.data.data || []);
                setShowUserDropdown(true);
            } else {
                setUserList([]);
            }
        }).catch(() => {
            setUserList([]);
        });
    };

    const handleUserSearchChange = (e) => {
        const value = e.target.value;
        setUserSearchTerm(value);
        if (value) {
            searchUsers(value);
        } else {
            setUserList([]);
            setShowUserDropdown(false);
            setSelectedUser(null);
            setUserId("");
        }
    };

    const selectUser = (user) => {
        setSelectedUser(user);
        setUserId(user.id);
        setUserSearchTerm(
            user.middle_name != null && user.middle_name != "null" ? 
                (user.first_name + " " + user.middle_name + " " + user.last_name) : 
                (user.first_name + " " + user.last_name)
        );
        setShowUserDropdown(false);
    };

    useEffect(() => {
        const handleClickOutside = (event) => {
            if (userDropdownRef.current && !userDropdownRef.current.contains(event.target)) {
                setShowUserDropdown(false);
            }
        };

        document.addEventListener('mousedown', handleClickOutside);
        return () => {
            document.removeEventListener('mousedown', handleClickOutside);
        };
    }, []);

    const createBannerAPI = () => {
        if (!userId) {
            toast.error("Please select a user");
            return;
        }
        if (!imageFile) {
            toast.error("Please upload an image");
            return;
        }

        var data = new FormData();
        data.append("user_id", userId);
        data.append("priority", priority);
        if (link) {
            data.append("link", link);
        }
        data.append("image", imageFile);

        setIsLoading(true);
        fetch('https://api.connecker.com/api/create_banner', {
            method: 'POST',
            body: data,
            headers: {
                'Authorization': `Bearer ${cookies.token}`
            }
        }).then(res => {
            setIsLoading(false);
            if(!res.ok) {
                throw Error('Could not fetch');
            }
            return res.json();
        }).then(async(data) => {
            setIsLoading(false);
            if(data.response_code == 200) {
                toast.success(data.message);
                setTimeout(() => {
                    history.push('/banners');
                }, 1000);
            } else {
                toast.error(data.message || 'Failed to create banner');
            }
        }).catch(() => {
            setIsLoading(false);
            toast.error('Failed to create banner');
        });
    }

    return(
        <div className="content">
            <div className="row d-flex justify-content-center">
                <div className="col-2 col-sm-2">
                    <Sidebar></Sidebar>
                </div>
                <div className="col-10 col-sm-10" style={{ paddingLeft: "40px" }}>
                    <Background></Background>
                    <h4 style={{ color:"white", marginTop:"50px" }}>Add Banner</h4>
                    <div className="card" style={{width:"100%"}}>
                        <div className="card-body">
                            <div className="d-flex">
                                <h6 style={{ color:"orange" }}>Basic</h6>
                                &nbsp;
                                <h6>Information</h6>
                            </div>
                            <br></br>
                            
                            {/* User Search */}
                            <div className="mb-3" style={{ position: "relative" }} ref={userDropdownRef}>
                                <label className="form-label" style={{ marginBottom: "8px", fontWeight: "500" }}>User *</label>
                                <input 
                                    type="text" 
                                    className="form-control"
                                    style={{ border:"1px solid lightgrey", borderRadius:"25px", padding:"10px", width:"17rem" }}
                                    placeholder="Search for user..."
                                    value={userSearchTerm}
                                    onChange={handleUserSearchChange}
                                    onFocus={() => {
                                        if (userSearchTerm && userList.length > 0) {
                                            setShowUserDropdown(true);
                                        }
                                    }}
                                />
                                {showUserDropdown && userList.length > 0 && (
                                    <div 
                                        className="dropdown-menu show"
                                        style={{
                                            position: "absolute",
                                            top: "100%",
                                            left: 0,
                                            zIndex: 1000,
                                            width: "17rem",
                                            maxHeight: "200px",
                                            overflowY: "auto",
                                            marginTop: "5px"
                                        }}
                                    >
                                        {userList.map((user) => (
                                            <button
                                                key={user.id}
                                                type="button"
                                                className="dropdown-item"
                                                onClick={() => selectUser(user)}
                                                style={{
                                                    padding: "8px 12px",
                                                    border: "none",
                                                    background: "white",
                                                    width: "100%",
                                                    textAlign: "left",
                                                    cursor: "pointer"
                                                }}
                                                onMouseEnter={(e) => {
                                                    e.target.style.backgroundColor = "#f8f9fa";
                                                }}
                                                onMouseLeave={(e) => {
                                                    e.target.style.backgroundColor = "white";
                                                }}
                                            >
                                                {user.middle_name != null && user.middle_name != "null" ? 
                                                    (user.first_name + " " + user.middle_name + " " + user.last_name) : 
                                                    (user.first_name + " " + user.last_name)
                                                }
                                                <br />
                                                <small style={{ color: "#666" }}>{user.email}</small>
                                            </button>
                                        ))}
                                    </div>
                                )}
                            </div>

                            {/* Priority */}
                            <div className="mb-3">
                                <label className="form-label" style={{ marginBottom: "8px", fontWeight: "500" }}>Priority</label>
                                <input 
                                    type="number" 
                                    className="form-control"
                                    style={{ border:"1px solid lightgrey", borderRadius:"25px", padding:"10px", width:"17rem" }}
                                    placeholder="Priority (default: 0)"
                                    value={priority}
                                    onChange={(e) => setPriority(Number(e.target.value) || 0)}
                                    min="0"
                                />
                            </div>

                            {/* Link */}
                            <div className="mb-3">
                                <label className="form-label" style={{ marginBottom: "8px", fontWeight: "500" }}>Link (optional)</label>
                                <input 
                                    type="url" 
                                    className="form-control"
                                    style={{ border:"1px solid lightgrey", borderRadius:"25px", padding:"10px", width:"17rem" }}
                                    placeholder="https://example.com"
                                    value={link}
                                    onChange={(e) => setLink(e.target.value)}
                                />
                            </div>

                            {/* Image Upload */}
                            <div className="mb-3">
                                <label className="form-label" style={{ marginBottom: "8px", fontWeight: "500" }}>Banner Image *</label>
                                {imagePreview && (
                                    <div className="mb-2">
                                        <img 
                                            src={imagePreview} 
                                            alt="Preview" 
                                            style={{ 
                                                width: "200px", 
                                                height: "120px", 
                                                objectFit: "cover",
                                                borderRadius: "8px",
                                                border: "1px solid #ddd"
                                            }}
                                        />
                                    </div>
                                )}
                                <div {...getRootProps()} className="container" style={{ borderRadius:"16px", height:"12rem", backgroundColor:"#FCC981", cursor: "pointer" }}>
                                    <input {...getInputProps()} />
                                    {
                                        !isDragActive ?
                                        <center>
                                            <FaCloudUploadAlt style={{ width:"5rem", height:"5rem", color:"#FF4500" }}></FaCloudUploadAlt>
                                            <br></br><br></br>
                                            <h5><b>Drop Files Or Click To Upload</b></h5>
                                        </center>
                                        :
                                        <div>
                                        </div>
                                    }
                                </div>
                            </div>
                            
                            <br></br>
                            <button 
                                onClick={() => createBannerAPI()} 
                                disabled={isLoading}
                                style={{ 
                                    color:"white",
                                    backgroundColor:"#FF4500",
                                    border:"1px solid #FF4500",
                                    borderRadius:"25px",
                                    padding:"10px",
                                    paddingLeft:"40px",
                                    paddingRight:"40px",
                                    margin:"5px",
                                    opacity: isLoading ? 0.6 : 1,
                                    cursor: isLoading ? "not-allowed" : "pointer"
                                }}
                            >
                                {isLoading ? 'Submitting...' : 'Submit'}
                            </button>
                        </div>
                    </div>
                </div>
            </div>
            <ToastContainer />
        </div>
    );
}

export default AddBanner;
